import utils from '@/utils';
import api from '@/utils/api';
import types from '@/store/types';

export default {
  methods: {
    actionHandler(action) {
      console.log("ACTION.type", action)
      let isHome = ["/", "/hair-rituel"].indexOf(this.$route.path) != -1;
      if (!action) return;
      let { type, route, data, preview_h5, preview_pc, preview_img_h5, preview_img_pc } = action;
      if (preview_h5 == 1 || preview_pc == 1) {
        let imgUrl = '';
        if (utils.isMobile() && preview_h5 == 1 && preview_img_h5) {
          imgUrl = preview_img_h5;
        } else if (preview_pc == 1 && preview_img_pc) {
          imgUrl = preview_img_pc;
        }
        imgUrl ? this.$store.commit("setEbaDialog", {
          dialog: true,
          url: imgUrl
        }) : console.warn(action);
      } else if (type == "outer_link") {
        window.open(data.path, "_blank");
      } else if (type == "inner_link") {
        let { pageKey, param } = route;
        let path = '';
        switch(pageKey) {
          case "cms":
            if (param == "home_hair") path = "/hair-rituel";
            else if (param == "home") path = "/";
            else path = `/landing?key=${param}`;
            break;
          case "category":
            path = `/category/${param}`;
            break;
          case "product":
            path = `/detail?id=${param}`;
            break;
          case "trial_by_post":
              utils.removeItem("trial_outer");
              path = `/trialconfirm?id=${param}`;
              break;
          case "home":
            path = `/`;
            break;
          default:
            path = `/`;
            console.warn(`[Header.vue@triggerHandler]: PageKey = ${pageKey}`);
            break;
        }
        if (isHome) {
          window.open(path, '_blank');
        } else {
          this.$router.push({ path });
        }
      } else if (type == "jump_app" && data.path) {
        //跳转到小程序
        const path = data?.path;
        if(path) {
          api[types.MIN_PROGRAMN]({path: path}).then(res => {
            if(res.message) { 
            window.location.href = res.message;
             //渠道上报
            api[types.REPORT_CHANNEL]({activityChannel:"jump_app",entrance:res.message}).then(res => {
              console.log(res);
            }).catch(err => {
              console.warn(err);
            });  
            }          
          });
        }
        this.$store.commit("setToast", true);
      } else if (type === 'coupon'){
        //领劵
        getCouponById(action.data);
      } else {
        console.log(`链接=（类型：${type}, 地址：${route}, 参数：${JSON.stringify(data)}）`);
      }
    }
  }
}

/**
 * 领取优惠卷
 * @data Object {
 *  coupon_id: ""
 * }
*/
export function getCouponById({coupon_id}) {
  if(!coupon_id) return  window.vm.$toast({ message: "未配置优惠券id", iconCls: "failure" });
  if(!localStorage.getItem("token")) return window.vm.$toast({ message: "请登录", iconCls: "failure" })
  api[types.GET_COUPON]({
    coupon_id: coupon_id,
  }).then(res => {
    if(res.message) { 
      window.vm.$toast({ message: res.message, iconCls: "success" })
    }          
  });
}